import { render } from "./OverlayInfo.vue?vue&type=template&id=44172dac&scoped=true"
import script from "./OverlayInfo.vue?vue&type=script&lang=js"
export * from "./OverlayInfo.vue?vue&type=script&lang=js"

import "./OverlayInfo.vue?vue&type=style&index=0&id=44172dac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44172dac"]])

export default __exports__